module.exports = __webpack_public_path__ + "static/img/bqs_ybamy.de0a5af.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/daily/bqs_ybamy.png
// module id = 528
// module chunks = 1